import React, { useState } from 'react'
import axios from "axios";

const Unsubscribe = () => {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false)
   
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const data =  {email: email}
        
        try {
            await axios.post(`${process.env.REACT_APP_STOIC_UNSUBSCRIBE}`, data)
        } catch (error) {
            return error;
        }

        setSubmitted(true)
    }
    return (
        <div>
            {submitted ? 
            (
            <div>
                <div className="flex justify-center text-3xl font-gray-800 font-bold">
                    Unsubscribed:<span className="ml-2 italic font-normal">"{email}"</span>
                </div>
                <div class="bg-white h-full flex flex-col items-center md:mx-10 px-4 sm:px-6 lg:px-8 bg-gray-100">
                    <div class="mt-3 md:mt-8 bg-white mb-8 max-w-7xl mx-auto max-w-sm rounded overflow-hidden shadow-md hover:shadow-2xl transition duration-500 ease-in-out">
                        <div class="bg-purple-500 h-2 w-full rounded-t-lg"></div>
                        <div class="stylistic-quote-mark text-gray-200 z-0 ml-1 md:ml-3 -mt-6 absolute" aria-hidden="true">“</div>
                        <div class="p-4 sm:px-2 md:px-8">
                            <div class="relative z-10 max-w-3xl mx-auto text-center text-xl md:text-2xl font-medium text-gray-900">
                                <p>Friends, the school of a philosopher is a hospital. When you leave, you should have suffered, not enjoyed yourself.</p>
                            </div>
                            <footer class="mt-4">
                                <div class="flex items-center justify-center">
                                    <a class="w-14 h-14 mr-3 overflow-hidden rounded-full" href="philosophers/Epictetus">
                                        <img alt="Epictetus" src="https://upload.wikimedia.org/wikipedia/commons/9/90/Epictetus.jpg"/>
                                    </a>
                                    <div class="text-center md:mt-0 md:ml-2 md:flex md:items-center">
                                        <a class="text-xl italic font-bold leading-6 font-medium hover:underline text-gray-900" href="/philosophers/Epictetus">
                                            Epictetus
                                        </a>
                                        <svg class="hidden md:block mx-1 h-5 w-5 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M11 0h3L9 20H6l5-20z"></path>
                                        </svg>
                                        <div class="text-lg italic leading-6 font-medium text-gray-500">
                                            Discourses III, 23.30
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>  
            ) 
            : 
            (
            <div className="mb-20">
                <div className="mb-2 flex justify-center font-gray-800 font-bold">
                Please enter an email to unsubscribe:
                </div>
                <form onSubmit={handleSubmit}>
                    <input type="email" name={email} placeholder="Email" onChange={e => setEmail(e.target.value)} className="mx-2 bg-white appearance-none border-2 rounded-md py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"/>
                    <input type="submit" value="Unsubscribe" className="mx-1 shadow bg-purple-800 hover:bg-purple-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"/>
                </form>
            </div>
            )}
        </div>    
    )
}

export default Unsubscribe
